import { Static, Type } from '@sinclair/typebox'
import { KizeoTenantTier } from '../../policy/tenant-policy'
import { TenantStatus } from '../../tenant/tenant'

// Headline category of what syncing this client with Corp would do. Computed
// server-side (single source of truth) so the UI just switches on it.
export const TenantSyncChangeKind = Type.Union([
    Type.Literal('no_change'), // Corp and Khub already aligned
    Type.Literal('plan_downgrade'), // business -> smart: enabled flows get disabled
    Type.Literal('access_lost'), // -> no_access: flows disabled + tenant deactivated
    Type.Literal('corp_not_found'), // customer absent from Corp: no action (fail-open)
    Type.Literal('regular_update'), // any other applied change (upgrade, reactivation, quota…)
])
export type TenantSyncChangeKind = Static<typeof TenantSyncChangeKind>

export const TenantSyncPreview = Type.Object({
    // Plan row. khubTier = last tier Khub recorded (drives the downgrade logic);
    // corpTier = fresh from Corp (null = customer not found).
    khubTier: Type.Union([KizeoTenantTier, Type.Null()]),
    corpTier: Type.Union([KizeoTenantTier, Type.Null()]),
    // Status row. statusAfter differs from current only on access_lost
    // (-> INACTIVE) or reactivation (-> ACTIVE).
    currentStatus: Type.Enum(TenantStatus),
    statusAfter: Type.Enum(TenantStatus),
    // Quota row. current = enforced (cached) policy; new = after sync (null = not found).
    currentMonthlyQuota: Type.Union([Type.Number(), Type.Null()]),
    newMonthlyQuota: Type.Union([Type.Number(), Type.Null()]),
    activeFlows: Type.Number(),
    activeFlowsAfter: Type.Number(),
    changeKind: TenantSyncChangeKind,
})

export type TenantSyncPreview = Static<typeof TenantSyncPreview>

export const TenantSyncResult = Type.Object({
    flowsDisabled: Type.Number(),
    downgradeReset: Type.Boolean(),
    statusChanged: Type.Union([Type.Enum(TenantStatus), Type.Null()]),
})

export type TenantSyncResult = Static<typeof TenantSyncResult>
